import { render, staticRenderFns } from "./SplashLinkForm.vue?vue&type=template&id=12dfa760&scoped=true&"
import script from "./SplashLinkForm.vue?vue&type=script&lang=js&"
export * from "./SplashLinkForm.vue?vue&type=script&lang=js&"
import style0 from "./SplashLinkForm.vue?vue&type=style&index=0&id=12dfa760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfa760",
  null
  
)

export default component.exports